import { PracticeType } from '@yi/core/src/gql/generated/typesClient';

export function isPranayama({ practiceType }: { practiceType: PracticeType }): boolean {
  return practiceType === PracticeType.PRANAYAMA;
}
